.appShell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--surface, #f8f9ff);
  color: var(--on-surface, #0d1c2e);
}

.workspaceBody {
  max-width: 1480px;
  width: 100%;
  margin: 0 auto;
  padding: 1.35rem 1.5rem 3.5rem;
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  flex: 1;
}

/* Barra lateral vertical izquierda — Exclusiva para vista de computadora */
.desktopSidebar {
  width: 284px;
  flex-shrink: 0;
  position: sticky;
  top: 78px;
  background: var(--surface-container-lowest, #ffffff);
  border: 1px solid var(--surface-container-high, #dce9ff);
  border-radius: 16px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  box-shadow: var(--shadow-card);
}

.sidebarHeaderTitle {
  font-family: var(--font-sans);
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--on-surface-variant, #444651);
  padding: 0.15rem 0.4rem;
}

.verticalNavList {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.verticalNavBtn {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.42rem;
  padding: 0.8rem 0.92rem;
  border-radius: 12px;
  background: var(--surface-container-low, #eff4ff);
  border: 1px solid var(--surface-container-high, #dce9ff);
  color: var(--on-surface-variant, #444651);
  cursor: pointer;
  text-align: left;
  transition: all 0.18s ease;
}

.verticalNavBtn:hover {
  background: var(--surface-container, #e6eeff);
  border-color: var(--primary-fixed-dim, #b6c4ff);
  color: var(--primary, #00236f);
}

.verticalNavBtnActive {
  background: linear-gradient(135deg, #00236f 0%, #1e3a8a 100%);
  border-color: #00236f;
  color: #ffffff;
  box-shadow: var(--shadow-sapphire);
}

.verticalNavBtnActive:hover {
  background: linear-gradient(135deg, #00236f 0%, #1e3a8a 100%);
  color: #ffffff;
}

.verticalNavBtnTop {
  display: flex;
  align-items: center;
  gap: 0.55rem;
}

.verticalNavIcon {
  font-size: 1.05rem;
  line-height: 1;
}

.verticalNavLabel {
  font-family: var(--font-display);
  font-size: 0.85rem;
  font-weight: 700;
  line-height: 1.28;
}

.verticalNavBadge {
  font-family: var(--font-sans);
  font-size: 0.68rem;
  font-weight: 600;
  padding: 0.14rem 0.55rem;
  border-radius: 999px;
  background: rgba(134, 242, 228, 0.45);
  border: 1px solid rgba(0, 106, 97, 0.22);
  color: var(--secondary, #006a61);
  font-variant-numeric: tabular-nums;
}

.verticalNavBtnActive .verticalNavBadge {
  background: rgba(137, 245, 231, 0.2);
  border-color: rgba(137, 245, 231, 0.4);
  color: #89f5e7;
}

.main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1.35rem;
}

.toastBanner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.85rem 1.15rem;
  border-radius: var(--radius-md);
  background: linear-gradient(90deg, rgba(134, 242, 228, 0.45), rgba(220, 225, 255, 0.6));
  border: 1px solid rgba(0, 106, 97, 0.3);
  color: var(--on-surface, #0d1c2e);
  font-size: 0.84rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  box-shadow: var(--shadow-card);
}

.toastDismiss {
  background: #ffffff;
  border: 1px solid var(--surface-container-high, #dce9ff);
  border-radius: 6px;
  padding: 0.22rem 0.58rem;
  color: var(--primary, #00236f);
  cursor: pointer;
  font-family: var(--font-sans);
  font-weight: 600;
  font-size: 0.76rem;
}

.dashboardMiddleGrid {
  display: grid;
  grid-template-columns: 1.35fr 1fr;
  gap: 1.25rem;
}

.captureSectionCard {
  background: var(--surface-container-lowest, #ffffff);
  border: 1px solid var(--surface-container-high, #dce9ff);
  border-radius: 16px;
  padding: 1.25rem 1.4rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-shadow: var(--shadow-card);
}

.captureHeaderBar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}

.captureHeaderTitle {
  font-family: var(--font-display);
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--primary, #00236f);
  margin: 0;
}

.captureHeaderSub {
  font-size: 0.8rem;
  color: var(--on-surface-variant, #444651);
  margin: 0.18rem 0 0 0;
}

.captureModeTabs {
  display: inline-flex;
  background: var(--surface-container-low, #eff4ff);
  border: 1px solid var(--surface-container-highest, #d5e3fc);
  border-radius: 12px;
  padding: 0.25rem;
  gap: 0.35rem;
  flex-wrap: wrap;
}

.captureModeBtn {
  border: none;
  background: transparent;
  color: var(--on-surface-variant, #444651);
  font-size: 0.82rem;
  font-weight: 600;
  padding: 0.48rem 0.9rem;
  border-radius: 8px;
  cursor: pointer;
}

.captureModeBtnActive {
  background: var(--surface-container-lowest, #ffffff);
  color: var(--primary, #00236f);
  font-weight: 700;
  box-shadow: 0 1px 3px rgba(0, 35, 111, 0.08);
}

.progressiveDisclosureBar {
  background: var(--surface-container-lowest, #ffffff);
  border: 1px solid var(--surface-container-high, #dce9ff);
  border-radius: 16px;
  padding: 1rem 1.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  box-shadow: var(--shadow-card);
}

.progressiveDisclosureText {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.progressiveDisclosureTitle {
  font-family: var(--font-display);
  font-size: 0.92rem;
  font-weight: 700;
  color: var(--on-surface, #0d1c2e);
}

.progressiveDisclosureHint {
  font-size: 0.78rem;
  color: var(--on-surface-variant, #444651);
}

.progressiveDisclosureBtn {
  background: var(--primary-fixed, #dce1ff);
  border: 1px solid rgba(0, 35, 111, 0.18);
  color: var(--primary, #00236f);
  font-size: 0.82rem;
  font-weight: 700;
  padding: 0.58rem 1.05rem;
  border-radius: 10px;
  cursor: pointer;
}

.progressiveDisclosureBtn:hover {
  background: #cbd4ff;
}

.detailedSectionStack {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

/* Vista Computadora (> 900px): Monitoreo, Revisión y Detalles en primer plano */
.desktopMonitoringStack {
  display: flex;
  flex-direction: column;
  gap: 1.35rem;
}

.desktopMonitoringSection {
  background: var(--surface-container-lowest, #ffffff);
  border: 1px solid var(--surface-container-high, #dce9ff);
  border-radius: 16px;
  padding: 1.3rem 1.45rem;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  box-shadow: var(--shadow-card);
}

.desktopMonitoringHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  padding-bottom: 0.65rem;
  border-bottom: 1px solid var(--surface-container-high, #dce9ff);
}

.desktopModePill {
  font-family: var(--font-sans);
  font-size: 0.73rem;
  font-weight: 700;
  padding: 0.3rem 0.78rem;
  border-radius: 999px;
  background: rgba(134, 242, 228, 0.45);
  border: 1px solid rgba(0, 106, 97, 0.22);
  color: var(--secondary, #006a61);
}

/* Vista Celular (<= 900px): Captura Rápida con Cámara en primer plano */
.mobileQuickCaptureStack {
  display: none;
}

/* Botón Redondo Flotante en el lado derecho — Solo Celular */
.mobileFloatingContainer {
  display: none;
}

.mobileFabBackdrop {
  position: fixed;
  inset: 0;
  background: rgba(13, 28, 46, 0.42);
  backdrop-filter: blur(4px);
  z-index: 90;
}

.mobileFabButtonStack {
  position: fixed;
  right: 1.15rem;
  top: 58%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.78rem;
  z-index: 95;
}

.hiddenCameraInput {
  display: none;
}

.mobileCameraFabTrigger {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  background: linear-gradient(135deg, #006a61 0%, #0d9488 100%);
  border: 2px solid #ffffff;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 10px 25px rgba(0, 106, 97, 0.35);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.mobileCameraFabTrigger:active {
  transform: scale(0.94);
}

.mobileFabTrigger {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  background: var(--primary, #00236f);
  border: 2px solid #ffffff;
  color: #ffffff;
  font-size: 1.45rem;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 10px 25px rgba(0, 35, 111, 0.35);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.mobileFabTrigger:active,
.mobileFabTriggerActive {
  transform: scale(0.94);
  background: var(--primary-container, #1e3a8a);
  color: #ffffff;
}

.mobileFabMenu {
  position: fixed;
  right: 5.2rem;
  top: 62%;
  transform: translateY(-50%);
  width: min(300px, calc(100vw - 6.4rem));
  background: var(--surface-container-lowest, #ffffff);
  border: 1px solid var(--surface-container-highest, #d5e3fc);
  border-radius: 16px;
  padding: 0.9rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  box-shadow: var(--shadow-modal);
  z-index: 95;
}

.mobileFabMenuTitle {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--primary, #00236f);
  padding: 0.1rem 0.35rem 0.25rem;
}

.mobileFabOptionBtn {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.32rem;
  padding: 0.7rem 0.82rem;
  border-radius: 11px;
  background: var(--surface-container-low, #eff4ff);
  border: 1px solid var(--surface-container-high, #dce9ff);
  color: var(--on-surface, #0d1c2e);
  font-size: 0.82rem;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
}

.mobileFabOptionBtnActive {
  background: linear-gradient(135deg, #00236f 0%, #1e3a8a 100%);
  border-color: #00236f;
  color: #ffffff;
}

.mobileFabOptionMain {
  display: flex;
  align-items: center;
  gap: 0.45rem;
}

.mobileFabOptionBadge {
  font-family: var(--font-sans);
  font-size: 0.66rem;
  font-weight: 700;
  padding: 0.12rem 0.46rem;
  border-radius: 999px;
  background: rgba(134, 242, 228, 0.5);
  color: var(--secondary, #006a61);
}

.mobileFabOptionBtnActive .mobileFabOptionBadge {
  background: rgba(137, 245, 231, 0.22);
  color: #89f5e7;
}

.footer {
  border-top: 1px solid var(--surface-container-high, #dce9ff);
  background: var(--surface-container-lowest, #ffffff);
  padding: 1.15rem 1.5rem;
  text-align: center;
  font-size: 0.76rem;
  color: var(--on-surface-variant, #444651);
  font-family: var(--font-sans);
}

@media (max-width: 1080px) {
  .dashboardMiddleGrid {
    grid-template-columns: 1fr;
  }
}

/* Vista de Celular / Móvil */
@media (max-width: 900px) {
  .workspaceBody {
    padding: 0.85rem 0.85rem 4.8rem;
  }

  .main {
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }

  .desktopSidebar {
    display: none;
  }

  .desktopMonitoringStack {
    display: none;
  }

  .mobileQuickCaptureStack {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    min-width: 0;
  }

  .progressiveDisclosureBar {
    padding: 0.9rem 1rem;
  }

  .progressiveDisclosureBtn {
    width: 100%;
    text-align: center;
  }

  .mobileFloatingContainer {
    display: block;
  }
}
